import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { CatalogContainer, ProductContainer, Sidebar } from './styles';
import SearchBar from '../../../../components/Purchase/SearchBar';
import Filters from '../../../../components/Purchase/Filters';
import { FiltersProvider } from '../../../../providers/filters.provider';
import { ShoppingCartBottomBar } from '../../../../components/Purchase/BottomBar';
import { ApplicationState } from '../../../../store';
import { BlockedModal } from '../../../../components/Purchase/BlockedModal';
import { useDispatch } from 'react-redux';
import { cleanShoppingCart } from '../../../../store/ducks/long-steel-shopping-cart/actions';
import useCatalogService from '../../../../services/MVP/useCatalogService';
import {
  ProductDescription,
  ProductType,
  SearchOptionsProps,
  SortProductsItem,
  SortProductsProps,
  ValidationModalProps
} from '../../../../services/MVP/models';
import LoadingModal from '../../../../components/LoadingModal';
import { ITaggingParams } from '../../../../store/ducks/tagging/types';
import { sendTagging } from '../../../../store/ducks/tagging/actions';
import { GridContainer } from '../../../../components/Purchase/GridContainer';
import ProductCard from '../../../../components/Purchase/ProductCard';
import { useLocation } from 'react-router-dom';
import MessageChooseItem from '../../../../components/MessageChooseItem';
import { ValidationModal } from '../ShoppingCartMVP/ValidationModal';
import { useLoadingModal } from '../../../../context/useModaContext';
import { CatalogPagination } from './CatalogPagination';
import { GetFlag } from '../../../../utils/featureFlag';
import { usePricingService } from '../../../../services/MVP/usePricingService';

interface IfilterTaggingObject {
  event: string;
  screenName: string;
  etapa: string;
  cod_produto: string;
  ordernation: string;
  [key: string]: string;
}

const CatalogPage = () => {
  const { sortProducts, searchProducts, productsTypes } = useCatalogService();
  const { setLoadingModalOpen, shouldShowOnlyLoading } = useLoadingModal();
  const { getPrice } = usePricingService();
  const dispatch = useDispatch();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const gpd = searchParams.get('gpd')?.trim();
  const { emitterId } = useSelector(
    (state: ApplicationState) => state.longSteelShoppingCart
  );
  const {
    customers,
    loading,
    loadingProductDescription,
    loadingPurchaseReceivers,
    loadingBlocks,
    loadingCustomerById
  } = useSelector((state: ApplicationState) => state.customers);
  const selectedCustomer = customers.find((c) => c.customerId === emitterId);

  const isBlockedCustomer =
    selectedCustomer?.blocks &&
    selectedCustomer?.blocks?.filter((blc) => blc.type === 'order')?.length > 0;

  const newSearchItemsEndpointFlag = GetFlag('new_search_items_endpoint');

  const descriptionResponse =
    newSearchItemsEndpointFlag || selectedCustomer?.productsDescriptionResponse;

  const getFirstProductPaymentCondition = (): string | undefined => {
    if (!newSearchItemsEndpointFlag || !products?.products) {
      return undefined;
    }
    for (const prd of products.products) {
      const price = getPrice(prd);
      if (price?.paymentTermsDescription) {
        return price.paymentTermsDescription;
      }
    }
    return undefined;
  };

  const descricao_gpm = (product: SortProductsItem) => {
    return (
      product.custom_attributes.find(
        (att: { attribute_code: string }) =>
          att.attribute_code === 'descricao_gpm'
      )?.value ?? ''
    );
  };

  const [openBlockedModal, setOpenBlockedModal] = useState(isBlockedCustomer);
  const [productsTypesList, setProductsTypesList] = useState<ProductType[]>();
  const [searchDataAC, setSearchDataAC] = useState<ProductDescription[]>([]);
  const [searchOptions, setSearchOptions] = useState<SearchOptionsProps>({
    filters: {
      materialCode: 'gerdauCode',
      ordenation: 'R',
      productsTypes: [''],
      input: gpd ?? ''
    },
    pagination: {
      currentPage: 1,
      pageSize: 12
    }
  });
  const [validationModalInformation, setValidationModalInformation] =
    useState<ValidationModalProps>({
      show: false,
      title: '',
      description: '',
      handleNextBtn: () => null,
      handleNextBtnTitle: 'Continuar',
      hiddenLeftButton: false
    });

  const handleCloseValidationModal = () => {
    setValidationModalInformation((prev) => ({
      ...prev,
      show: false
    }));
  };

  const [products, setProducts] = useState<{
    products: SortProductsItem[];
    total: number;
  }>();
  const [sortLoading, setSortLoading] = useState(true);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const onCloseBlockedModal = () => {
    dispatch(cleanShoppingCart());
    setOpenBlockedModal(false);
  };

  const customerLoading =
    loading ||
    !!loadingProductDescription ||
    !!loadingPurchaseReceivers ||
    !!loadingBlocks ||
    !!loadingCustomerById;

  const pageLoading = sortLoading || customerLoading;

  const getSortProducts = async ({
    options,
    products,
    showLoading = true,
    scrollToTopEnabled = true
  }: {
    options: SearchOptionsProps;
    products?: ProductDescription[];
    showLoading?: boolean;
    scrollToTopEnabled?: boolean;
    nextPage?: boolean;
    pagePreLoaded?: number;
  }) => {
    try {
      if (
        !customerLoading &&
        emitterId &&
        selectedCustomer &&
        !isBlockedCustomer &&
        descriptionResponse
      ) {
        if (showLoading) {
          setLoadingModalOpen(true);
          setSearchOptions((prev) => ({ ...prev, ...options }));
        }

        options.suggest = false;
        const data = await sortProducts({
          sortType: options.filters.ordenation,
          pageSize: options.pagination.pageSize,
          ...((!products ||
            ['R', 'AC', 'AB'].includes(options.filters.ordenation ?? '')) && {
            currentPage: options.pagination.currentPage
          }),
          ...(products && { productsSearch: products }),
          options
        });
        if (data.hasError) {
          setValidationModalInformation({
            title: 'Serviço indisponível temporariamente',
            description:
              'Tente novamente mais tarde ou entre em contato com o seu vendedor.',
            show: true,
            hiddenLeftButton: true,
            handleNextBtn: handleCloseValidationModal,
            handleNextBtnTitle: 'Continuar'
          });
          scrollToTop();
          setLoadingModalOpen(false);
          return;
        }

        if (scrollToTopEnabled) {
          scrollToTop();
        }

        return data;
      }
    } catch (error) {
      console.error('Error fetching search results:', error);
    } finally {
      setLoadingModalOpen(false);
    }
  };

  const getSearchProducts = async (options: SearchOptionsProps) => {
    try {
      if (
        !customerLoading &&
        emitterId &&
        selectedCustomer &&
        !isBlockedCustomer &&
        descriptionResponse
      ) {
        if (!options.shadowLoading) {
          setLoadingModalOpen(true);
          setSearchOptions(options);
        }
        scrollToTop();
        const hasProductsTypes =
          options.filters.productsTypes &&
          options.filters.productsTypes.filter((f) => f.length > 0);
        const hasInputSearch =
          options.filters.input && options.filters.input.length > 0;

        if (options.filters.materialCode === 'gerdauCode') {
          const data = await searchProducts({
            ...(hasProductsTypes && {
              sap_descricao_gpm: options.filters.productsTypes?.filter(
                (f) => f.length > 0
              )
            }),
            ...(hasInputSearch && {
              sku: options.filters.input
            }),
            ...(options.filters.ordenation === 'AC' && {
              searchType: 'AC'
            }),
            sortType: options.filters.ordenation,
            currentPage: options.pagination.currentPage,
            pageSize: options.pagination.pageSize
          });
          setLoadingModalOpen(false);
          return data;
        } else {
          const data = await searchProducts({
            ...(hasProductsTypes && {
              sap_descricao_gpm: options.filters.productsTypes?.filter(
                (f) => f.length > 0
              )
            }),
            ...(hasInputSearch && {
              internalCode: options.filters.input
            }),
            ...(options.filters.ordenation === 'AC' && {
              searchType: 'AC'
            }),
            sortType: options.filters.ordenation,
            currentPage: options.pagination.currentPage,
            pageSize: options.pagination.pageSize
          });
          return data;
        }
      }
    } catch (error) {
      console.error('Error fetching search results:', error);
    } finally {
      if (!options.shadowLoading) {
        setLoadingModalOpen(false);
      }
    }
  };

  const handlePagination = async ({
    currentPage = 1,
    pageSize = 12
  }: {
    currentPage?: number;
    pageSize?: number;
  } = {}) => {
    try {
      if (products?.products && products?.products?.length > 0 && sortLoading) {
        return null;
      }

      setSortLoading(true);

      if (
        searchOptions.filters.ordenation &&
        ['R', 'AC', 'AB'].includes(searchOptions.filters.ordenation) &&
        !gpd?.length
      ) {
        const sortResponse = await getSortProducts({
          options: {
            ...searchOptions,
            pagination: { currentPage, pageSize }
          },
          products: searchDataAC ?? []
        });
        setProducts({
          products: sortResponse?.products ?? [],
          total: sortResponse?.total ?? 0
        });
      } else {
        let sortResponse;
        let searchData;
        if (newSearchItemsEndpointFlag) {
          sortResponse = await getSortProducts({
            options: {
              ...searchOptions,
              pagination: {
                currentPage: 0,
                pageSize
              }
            }
          });
        } else {
          searchData = await getSearchProducts({
            ...searchOptions,
            pagination: {
              currentPage,
              pageSize
            },
            shadowLoading: false
          });

          sortResponse = await getSortProducts({
            options: {
              ...searchOptions,
              pagination: {
                // Enviar página 0 pois a sort nao buscará mais produtos
                currentPage: 0,
                pageSize
              }
            },
            products: searchData?.products
          });
        }

        setProducts({
          products: sortResponse?.products ?? [],
          total:
            searchOptions.filters.ordenation === 'AB'
              ? searchData?.total ?? 0
              : sortResponse?.total ?? 0
        });
        setSortLoading(false);
      }
    } catch (e) {
      console.error(e);
    } finally {
      setSortLoading(false);
    }
  };

  const handleSortChange = async (order: SortProductsProps['sortType']) => {
    try {
      if (sortLoading) {
        return null;
      }

      setSortLoading(true);
      if (order === 'R') {
        const sortResponse = await getSortProducts({
          options: {
            ...searchOptions,
            pagination: {
              ...searchOptions.pagination,
              currentPage: 1
            },
            filters: {
              ...searchOptions.filters,
              ordenation: order
            }
          }
        });

        setProducts({
          products: sortResponse?.products ?? [],
          total: sortResponse?.total ?? 0
        });
      } else if (order === 'AB') {
        let sortResponse;
        let searchData;
        if (newSearchItemsEndpointFlag) {
          sortResponse = await getSortProducts({
            options: {
              ...searchOptions,
              pagination: {
                ...searchOptions.pagination,
                currentPage: 1
              },
              filters: {
                ...searchOptions.filters,
                ordenation: order
              }
            }
          });
        } else {
          searchData = await getSearchProducts({
            ...searchOptions,
            pagination: {
              ...searchOptions.pagination,
              currentPage: 1
            },
            filters: {
              ...searchOptions.filters,
              ordenation: order
            },
            shadowLoading: false
          });
          sortResponse = await getSortProducts({
            products: searchData?.products,
            options: {
              ...searchOptions,
              pagination: {
                ...searchOptions.pagination,
                currentPage: 1
              },
              filters: {
                ...searchOptions.filters,
                ordenation: order
              }
            }
          });
        }

        setProducts({
          products: sortResponse?.products ?? [],
          total: sortResponse?.total ?? 0
        });
      } else if (order === 'WL') {
        const sortResponse = await getSortProducts({
          options: {
            ...searchOptions,
            pagination: { ...searchOptions.pagination, currentPage: 1 },
            filters: { ...searchOptions.filters, ordenation: order }
          }
        });
        setProducts({
          products: sortResponse?.products ?? [],
          total: sortResponse?.total ?? 0
        });
      } else {
        // Caso de ordenação por acordo de preço
        let sortResponse;
        let searchData;
        if (newSearchItemsEndpointFlag) {
          sortResponse = await getSortProducts({
            options: {
              ...searchOptions,
              pagination: {
                ...searchOptions.pagination,
                currentPage: 1
              },
              filters: {
                ...searchOptions.filters,
                ordenation: order
              }
            }
          });
        } else {
          searchData = await getSearchProducts({
            ...searchOptions,
            pagination: {
              ...searchOptions.pagination,
              currentPage: 1
            },
            filters: {
              ...searchOptions.filters,
              ordenation: order
            },
            shadowLoading: false
          });

          sortResponse = await getSortProducts({
            options: {
              ...searchOptions,
              pagination: {
                ...searchOptions.pagination,
                currentPage: 1
              },
              filters: {
                ...searchOptions.filters,
                ordenation: order
              }
            },
            products: searchData?.products ?? []
          });
        }
        setSearchDataAC(searchData?.products ?? []);
        setProducts({
          products: sortResponse?.products ?? [],
          total: sortResponse?.total ?? 0
        });
      }
    } catch (e) {
      console.error(e);
    } finally {
      setSortLoading(false);
    }
  };

  const handleSearchChange = async (
    value: SearchOptionsProps['filters'],
    noChanges?: boolean
  ) => {
    if (noChanges) {
      setSearchOptions((prev) => ({ ...prev, filters: value }));
      return;
    }

    try {
      if (sortLoading) {
        return null;
      }
      setSortLoading(true);
      let sortResponse;
      let searchData;
      if (newSearchItemsEndpointFlag) {
        sortResponse = await getSortProducts({
          options: {
            ...searchOptions,
            pagination: {
              pageSize: searchOptions.pagination.pageSize,
              currentPage: 1
            },
            filters: {
              ...searchOptions.filters,
              ...value
            }
          }
        });
      } else {
        searchData = await getSearchProducts({
          ...searchOptions,
          pagination: {
            pageSize: searchOptions.pagination.pageSize,
            currentPage: 1
          },
          filters: {
            ...searchOptions.filters,
            ...value
          },
          shadowLoading: false
        });
        sortResponse = await getSortProducts({
          options: {
            ...searchOptions,
            pagination: {
              pageSize: searchOptions.pagination.pageSize,
              currentPage: 1
            },
            filters: {
              ...searchOptions.filters,
              ...value
            }
          },
          products: searchData?.products
        });
      }

      setProducts({
        products: sortResponse?.products ?? [],
        total:
          searchOptions.filters.ordenation === 'AB'
            ? searchData?.total ?? 0
            : sortResponse?.total ?? 0
      });
    } catch (e) {
      console.error(e);
    } finally {
      setSortLoading(false);
    }
  };

  useEffect(() => {
    localStorage.setItem('tipo_compra', 'vitrine');
    const viewItemListTagging: ITaggingParams = {
      event: 'view_item_list',
      ecommerce: {
        screenName: 'comprar_por_vitrine',
        tipo_compra: 'vitrine',
        paginacao: searchOptions.pagination.currentPage.toString() ?? '',
        items: Array.isArray(products?.products)
          ? products?.products
              .filter((prd) => prd.id)
              .map((prd) => {
                const price = getPrice(prd);
                return {
                  screenName: 'vitrine',
                  price: price?.creditPrice,
                  unidade_de_medida: price?.um,
                  item_id: `${prd.sku}`,
                  item_name: prd.name,
                  tipo_compra: localStorage.getItem('tipo_compra') ?? '',
                  item_category: descricao_gpm(prd),
                  cod_gerdau: prd.sku,
                  preco_acordado: price?.isAgreementPrice?.length > 0,
                  quantity: '1',
                  favoritado:
                    prd.extension_attributes?.added_to_wishlist ?? false
                };
              })
          : []
      }
    };
    if (
      products &&
      Array.isArray(products?.products) &&
      products?.products.length > 0
    ) {
      filterVisibleProducts(viewItemListTagging);
    }
  }, [products]);

  function filterVisibleProducts(viewItemListTagging: ITaggingParams) {
    const itemListEvent = viewItemListTagging;

    if (
      !itemListEvent ||
      !itemListEvent.ecommerce ||
      !itemListEvent.ecommerce.items
    ) {
      return;
    }

    const productElements = document.querySelectorAll('.product-cards');

    const observer = new IntersectionObserver(
      function (entries) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const visibleProducts: any[] = [];

        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            const productIndex = Array.prototype.indexOf.call(
              productElements,
              entry.target
            );

            if (itemListEvent.ecommerce?.items) {
              const productData = itemListEvent.ecommerce.items[productIndex];

              if (productData && visibleProducts.indexOf(productData) === -1) {
                visibleProducts.push(productData);
              }
            }
          }
        });

        if (visibleProducts.length > 0) {
          window.dataLayer.push({
            event: 'view_item_list',
            ecommerce: {
              screenName: 'comprar_por_vitrine',
              tipo_compra: 'vitrine',
              paginacao: searchOptions.pagination.currentPage.toString(),
              items: visibleProducts
            }
          });
        }
      },
      {
        threshold: 0.5
      }
    );

    productElements.forEach(function (product) {
      observer.observe(product);
    });
  }

  const filterTaggingObject: IfilterTaggingObject = {
    event: 'filtros_vitrine',
    screenName: 'comprar_por_vitrine',
    etapa: 'lista_de_produtos',
    cod_produto: searchOptions.filters.materialCode ?? '',
    ordernation: searchOptions.filters.ordenation ?? ''
  };
  useEffect(() => {
    searchOptions.filters.productsTypes
      ?.filter((f) => f.length !== 0)
      .forEach((f, i) => {
        filterTaggingObject[`filtro_${i}`] = f;
      });

    if (
      (searchOptions.filters.productsTypes?.length ?? 0) > 0 &&
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      (searchOptions.filters.productsTypes![0] ?? ' ') != ''
    ) {
      dispatch(sendTagging(filterTaggingObject));
    }
  }, [
    searchOptions.filters.materialCode,
    searchOptions.filters.ordenation,
    searchOptions.filters.productsTypes
  ]);

  const filterTaggingProducNotFound: ITaggingParams = {
    event: 'nenhum_produto_encontrado',
    screenName: 'comprar_por_vitrine',
    termo_pesquisado: searchOptions.filters.input ?? '',
    filtros:
      searchOptions.filters.materialCode +
      ',' +
      searchOptions.filters.ordenation +
      ',' +
      (searchOptions.filters.productsTypes?.toString() ?? '')
  };

  useEffect(() => {
    if (products?.products.length === 0 && !pageLoading) {
      dispatch(sendTagging(filterTaggingProducNotFound));
    }
  }, [searchOptions.filters, products]);

  useEffect(() => {
    setOpenBlockedModal(isBlockedCustomer);
  }, [selectedCustomer]);

  useEffect(() => {
    (async () => {
      try {
        setSortLoading(true);
        if (
          !customerLoading &&
          emitterId &&
          selectedCustomer &&
          !isBlockedCustomer &&
          descriptionResponse
        ) {
          const productsTypesData = await productsTypes();
          setProductsTypesList(productsTypesData ?? []);
          await handlePagination();
        }
      } catch (error) {
        console.error(error);
      } finally {
        setSortLoading(false);
      }
    })();
  }, [customerLoading, emitterId, descriptionResponse]);

  if (!loading && (!emitterId || !selectedCustomer || isBlockedCustomer)) {
    return (
      <>
        {openBlockedModal && (
          <BlockedModal onCloseModal={onCloseBlockedModal} />
        )}
        <MessageChooseItem message="Selecione emissor e recebedor para continuar."></MessageChooseItem>
      </>
    );
  }

  return (
    <>
      <LoadingModal
        enabled={pageLoading || shouldShowOnlyLoading}
        title="Aguarde alguns instantes"
        message="Carregando os dados..."
      />
      <ValidationModal
        {...validationModalInformation}
        loading={loading}
        handleCloseValidationModal={handleCloseValidationModal}
      />

      <FiltersProvider>
        <CatalogContainer>
          <Sidebar>
            <Filters
              handleSearchChange={handleSearchChange}
              searchOptions={searchOptions}
              sortLoading={sortLoading}
              handleSortChange={handleSortChange}
              productsTypesList={productsTypesList ?? []}
              key={emitterId}
              paymentCondition={getFirstProductPaymentCondition()}
            />
          </Sidebar>
          <ProductContainer>
            <SearchBar
              handleSearchChange={handleSearchChange}
              searchOptions={searchOptions}
              key={searchOptions.filters.materialCode}
              setLoading={setSortLoading}
            />
            <GridContainer gap="1.5rem">
              {products &&
                products?.products &&
                Array.isArray(products?.products) &&
                products?.products.map((prd) => {
                  if (!prd.id) {
                    return null;
                  }
                  const price = getPrice(prd);
                  const agreementPrice = price?.isAgreementPrice?.length !== 0;
                  const image = prd?.media_gallery_entries?.[0]?.file
                    ? {
                        desktopSource: `${
                          process.env.REACT_APP_MEDIA_BASE_URL
                        }/media/catalog/product/${
                          prd.media_gallery_entries[0].file ?? ''
                        }`
                      }
                    : prd?.extension_attributes?.category_links &&
                      Array.isArray(
                        prd?.extension_attributes?.category_links
                      ) &&
                      prd?.extension_attributes?.category_links.length > 0 &&
                      prd?.extension_attributes?.category_links[0]
                        ?.category_image
                    ? {
                        desktopSource: `${
                          process.env.REACT_APP_MEDIA_BASE_URL
                        }${
                          prd.extension_attributes?.category_links[0]
                            ?.category_image ?? ''
                        }`
                      }
                    : undefined;

                  return (
                    <ProductCard
                      key={prd.sku}
                      agreedPrice={agreementPrice}
                      image={image}
                      showLink={false}
                      product={prd}
                      typeCode={searchOptions.filters.materialCode}
                    />
                  );
                })}
            </GridContainer>

            <CatalogPagination
              handleSearchChange={handleSearchChange}
              handleChange={handlePagination}
              total={products?.total ?? 0}
              catalogFilters={searchOptions.filters}
              productsLength={products?.products?.length ?? 0}
              selectedPage={searchOptions.pagination.currentPage}
              key={JSON.stringify(searchOptions.filters.productsTypes)}
            />
          </ProductContainer>
        </CatalogContainer>
      </FiltersProvider>
      <ShoppingCartBottomBar loading={pageLoading} />
    </>
  );
};
export default CatalogPage;
